import { fetchMenus } from '../../canopy-ui-components/api';
import { MenuType } from './MenuGroup';

export const dataFormatter = (data: any[]) => {
    if (Array.isArray(data)) {
        if (data?.[0]?.group_key) {
            return data.map((item: any) => {
                return {
                    [item.group_key]: item.group_values.map(
                        (menuMapping: any) => {
                            let appId: any = [];
                            const { details } = menuMapping;
                            details.forEach((app: any) => {
                                appId.push(app?.app_id);
                            });
                            const menus: any = fetchMenus(menuMapping);
                            return {
                                ...menuMapping,
                                app_id: appId,
                                navbar: menus?.filter(
                                    (menu: MenuType) =>
                                        menu.type === 'menu-navbar'
                                ),
                                sidebar: menus?.filter(
                                    (menu: MenuType) =>
                                        menu.type === 'menu-sidebar'
                                ),
                            };
                        }
                    ),
                };
            });
        } else {
            return data?.map((menuMapping) => {
                let appId: any = [];
                const { details } = menuMapping;
                details.forEach((app: any) => {
                    appId.push(app?.app_id);
                });
                const menus: any = fetchMenus(menuMapping);
                return {
                    ...menuMapping,
                    app_id: appId,
                    navbar: menus?.filter(
                        (menu: MenuType) => menu.type === 'menu-navbar'
                    ),
                    sidebar: menus?.filter(
                        (menu: MenuType) => menu.type === 'menu-sidebar'
                    ),
                };
            });
        }
    }
    return data;
};
